import classNames from "classnames";
import { graphql } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import React from "react";
import ExtractRichText from "../../molecules/ExtractRichText";
import "./mediaBlendContentBlock.scss";

export const ParagraphMediaBlendContentBlock = ({ node }) => {
  const {
    field_component_title,
    field_only_image,
    field_heading,
    field_summary,
    field_caption,
    field_image_credit,
    field_background_color,
    relationships,
  } = node;

  const { field_card_image, field_cta_link } = relationships ?? {};

  const hasImage = Boolean(field_card_image?.relationships?.field_media_image);
  const hasContent = !field_only_image && Boolean(field_summary);
  const hasCaption = Boolean(field_caption?.proceseed || field_image_credit);
  const blendFull = hasImage && hasContent;
  const image = getImage(
    relationships?.field_card_image?.relationships?.field_media_image
  );

  return (
    <div className="media-blend-root">
      {Boolean(field_component_title) && (
        <h1 className="media-blend-title">{field_component_title}</h1>
      )}
      <div
        className={classNames(
          "media-blend",
          `bg-clr-${field_background_color}`,
          { "media-blend-full": blendFull }
        )}
      >
        {hasImage && (
          <div className="media-blend-image">
            <GatsbyImage
              loading="lazy"
              className="media-blend-image-gatsby"
              image={image}
              alt={field_heading}
            />
            {hasCaption && (
              <div className="media-blend-image-caption">
                <div className="media-blend-image-caption-inner">
                  {Boolean(field_caption?.processed) && (
                    <div
                      className="media-blend-image-caption-info"
                      dangerouslySetInnerHTML={{
                        __html: field_caption?.processed,
                      }}
                    />
                  )}
                  {Boolean(field_image_credit) && (
                    <p className="media-blend-image-caption-rights">
                      {field_image_credit}
                    </p>
                  )}
                </div>
              </div>
            )}
          </div>
        )}
        {hasContent && (
          <div className="media-blend-content">
            <h4>{field_heading}</h4>
            <ExtractRichText richText={field_summary.processed} />
            <div className="media-blend-cta">
              {field_cta_link
                ?.filter((cta) => cta?.field_link?.title)
                .map((cta) => (
                  <a
                    href={cta?.field_link?.url || ""}
                    target={cta?.field_link?.options?.attributes?.target}
                    rel={cta?.field_link?.options?.attributes?.rel}
                    aria-label={
                      cta?.field_link?.options?.attributes?.aria_label
                    }
                    className={`btn btn-${cta?.field_cta_colour} ${cta?.field_link?.options?.attributes?.class}`}
                  >
                    {cta?.field_link?.title}
                  </a>
                ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export const fragment = graphql`
  fragment ParagraphMediaBlendContentBlock on paragraph__media_blend_content_block {
    field_heading
    field_caption {
      processed
    }
    field_only_image
    field_image_credit
    field_component_title
    field_summary {
      processed
    }
    field_background_color
    relationships {
      field_card_image {
        relationships {
          field_media_image {
            gatsbyImage(width: 1200, placeholder: BLURRED, quality: 100)
          }
        }
      }
      field_cta_link {
        type: __typename
        ...ParagraphLinks
      }
    }
  }
`;
